module.exports = __webpack_public_path__ + "icon-link-4ab779153356770459b2eb86459a3c53.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/bundles/ui/SharePhotoModal/ShareLink/icon-link.svg
// module id = 2238
// module chunks = 6